import React from 'react';
import { PanelBody, PanelHeading, PanelWithoutForm, TextWithLineBreaks } from '../../components/elements';
import { ISurvey } from '../../components/Surveys/Interfaces/ISurvey';

export function SurveyDetailsNen3140SummaryAndAdvice(props: { survey: Required<ISurvey> }) {
    return (
        <PanelWithoutForm id="SummaryAndAdvice">
            <PanelHeading text="Samenvatting" icon="fa fa-file-text-o"></PanelHeading>
            <PanelBody whiteBackground={true}>
                <TextWithLineBreaks text={props.survey.summaryAndAdvice} />
            </PanelBody>
        </PanelWithoutForm>
    );
}
